export default __webpack_public_path__ + "assets/images/b960cdd782ec27080afae15726fd7bdf.svg";